export const displayLastUpdateTime = false; // turn on if we want this

export default displayLastUpdateTime;
